export default "__VITE_PUBLIC_ASSET__a73b6104__"